import { AccountStatus, ApiResult } from "@shoothill/core";
import { RegisterUserModel } from "Views/Register/RegisterUserModel";
import { ViewModelBase } from "@shoothill/core";
import validator from "validator";
import { FieldType } from "@shoothill/core";
import { RegisterUserDetailsModel } from "./RegisterUserDetailslModel";
import { AppUrls } from "AppUrls";
import { StoresInstance } from "Globals/Stores";

//Pass in <any> as the generic type because we are showing the use of nested classes
export class RegisterUserViewModel extends ViewModelBase<RegisterUserModel> {
    constructor() {
        super(new RegisterUserModel());
        console.log("Register View Model Created");
        //this.setDecorators(RegisterUserModel);
        this.meta = [
            ...this.validatorStorage.getTargetValidationMetadatas(RegisterUserModel as any, "", false, false),
            ...this.validatorStorage.getTargetValidationMetadatas(RegisterUserDetailsModel as any, "", false, false),
        ];
        let meta1 = this.validatorStorage.getTargetValidationMetadatas(RegisterUserModel as any, "", false, false);
        let meta2 = this.validatorStorage.getTargetValidationMetadatas(RegisterUserDetailsModel as any, "", false, false);
    }

    public register = async (): Promise<ApiResult<AccountStatus>> => {
        let response = await this.Post<AccountStatus>(AppUrls.Server.Account.Register, this.getModel);
        if (response.wasSuccessful) {
            StoresInstance.Domain.AccountStore.getLoginState(response.payload);
            this.history.push("/");
        } else {
            StoresInstance.Domain.OpenSnackBar("There was an error registering this user. " + response.errors[0].message, "error");
        }
        return response;
    };

    public async isFieldValid(fieldName: keyof FieldType<RegisterUserModel>, value: any): Promise<boolean> {
        let { isValid, errorMessage } = await this.validateDecorators(fieldName);

        //Overriding the decorators to check password fields
        if (fieldName === "confirmPassword") {
            errorMessage = this.isConfirmPasswordValid;
            isValid = errorMessage === "";
        }

        if (!isValid) {
            console.log(fieldName + " is invalid");
        }
        this.setError(fieldName, errorMessage);
        this.setValid(fieldName, isValid);

        return isValid;
    }

    public afterUpdate: undefined;
    public beforeUpdate: undefined;

    public get isConfirmPasswordValid(): string {
        if (this.getValue("password") !== this.getValue("confirmPassword") && this.getValue("password") !== "") return "Passwords must match";
        return "";
    }
}
